const APP_STORE = 'https://itunes.apple.com/in/app/ingoibibo/id1019426231?mt=8';
const PLAY_STORE =
  'https://play.google.com/store/apps/details?id=com.ingoibibo';

const SSO_ONE_LOGIN_URL = 'https://sso.go-mmt.com/';

const PASSWORD_MIN_CHAR_LENGTH = 8;

export { APP_STORE, PLAY_STORE, SSO_ONE_LOGIN_URL, PASSWORD_MIN_CHAR_LENGTH };
